import {AppRegistry} from 'react-native';
import {Application} from '../application';


AppRegistry.registerComponent('ReactNativeWeb', () => Application);
AppRegistry.runApplication('ReactNativeWeb', {
  rootTag: document.getElementById('react-native-app'),
});
